export const URL_ORDER_ITEM_LIST = "/v1/orderonline/item/site/list"
export const URL_ORDER_ITEM_DETAIL = "/v1/orderonline/item/site/get"
export const URL_ORDER_ITEM_CREATE = "/v1/orderonline/item/form/create"
export const URL_ORDER_ITEM_UPDATE = "/v1/orderonline/item/form/update"
export const URL_ORDER_ITEM_DELETE = "/v1/orderonline/item/form/delete"
export const URL_UPDATE_ITEM_INSTOCK = "/v1/orderonline/item/form/update-status"
